import React from 'react';
import { ORG_ID_KEY } from '@assetron/common/constants/constant';
import FinalizeSubsciptionLoading from './finalizeSubscriptionLoader/FinalizeSubsciptionLoading';
import Loader from './Loader';

function SubscriptionLoaderWrapper() {
  const storedOrgId = globalThis.localStorage.getItem(ORG_ID_KEY);
  const redirectLink = `/organizations/${storedOrgId}/subscriptions/status`;
  const currentPath = globalThis.location?.pathname;
  return currentPath === redirectLink ? (
    <FinalizeSubsciptionLoading />
  ) : (
    <Loader />
  );
}

export default SubscriptionLoaderWrapper;
